// @ts-strict-ignore
import { SystemConfigurationVO } from './system-configuration.vo';
import { Injectable } from '@angular/core';
import { ModelConversionService } from '../convert/model-conversion.service';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { Log } from '@shared/debug/log';
import { map, shareReplay } from 'rxjs/operators';
import { NotificationVO } from '../vo/notification.vo';
import { lastValueFrom, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SystemConfigurationService {
  private readonly loadSystemConfigurationUrl: string = 'configuration/';
  private readonly loadSystemNotificationsUrl: string = 'configuration/notifications';

  private _currentConfiguration = new SystemConfigurationVO();

  private readonly _systemConfiguration$: Observable<SystemConfigurationVO>;
  public get systemConfiguration$(): Observable<SystemConfigurationVO> {
    return this._systemConfiguration$;
  }

  constructor(private modelConversionService: ModelConversionService, private wagoApiClient: WagoApiClient) {
    this._systemConfiguration$ =
      wagoApiClient
        .get(this.loadSystemConfigurationUrl, null, {bypassActiveCheckAndSessionValidation: true})
        .pipe(
          map((response) => this.modelConversionService.convertSystemConfigurationVO(response)),
          shareReplay()
        );
  }

  public get currentConfiguration(): SystemConfigurationVO {
    return this._currentConfiguration;
  }

  public async loadSystemConfiguration(): Promise<void> {
    try {
      this._currentConfiguration = await lastValueFrom(this._systemConfiguration$);
    } catch (error) {
      Log.error('Could not load configuration: ', error);
    }
  }

  public loadSystemNotifications(): Promise<NotificationVO[]> {
    return this.wagoApiClient
      .get(this.loadSystemNotificationsUrl, null, { bypassActiveCheckAndSessionValidation: true })
      .pipe(map((response) => this.modelConversionService.convertNotificationVOs(response)))
      .toPromise();
  }
}
